import { combineReducers } from 'redux'
import benchModel from './benchModel'
import stove from'./stove'
import materialStore from './materialStore'
import materialImage from './materialImage'
import paneling from './paneling'
import saunaLighting from './saunaLightning'
import stoves from './stoves'
import ui from './ui'
import measurements from './measurements'
import contactDetails from './contactDetails'
import plan from './plan'
import planService from './planService'
import clientConfiguration from './clientConfiguration'
import optionPricing from './optionPricing'
import installProduct from './installProduct'
import feedback from './feedback'

const saunaMaterialApp = combineReducers({
    benchModel,
    stove,
    materialStore,
    materialImage,
    paneling,
    saunaLighting,
    installProduct,
    stoves,
    plan,
    planService,
    clientConfiguration,
    optionPricing,
    measurements,
    contactDetails,
    feedback,
    ui
})

export default saunaMaterialApp
